import { createFileRoute, Navigate } from "@tanstack/react-router";

/**
 * Properties for {@link SettingsRedirect}
 */
type SettingsRedirectProps = {};

/**
 * Redirect page for settings
 */
function SettingsRedirect(props: SettingsRedirectProps) {
    return <Navigate to={"/a/settings/general"} />;
}

export const Route = createFileRoute("/_admin/a/settings/")({
    component: SettingsRedirect,
});
